let i = 0;

document.addEventListener("DOMContentLoaded", function() {
    const lnks = document.querySelectorAll('.external');
    for(i=0; i<lnks.length; i++){ lnks[i].setAttribute('target','_blank'); }
    
    const navLnks = document.querySelectorAll('#main-nav nav div a');
    for(i=0; i<navLnks.length; i++){
        navLnks[i].addEventListener('click',function(e){
            const h = this.getAttribute('href');
            document.querySelector(h).scrollIntoView({ behavior: "smooth" });
            document.body.classList.remove('mobile-open');
            e.preventDefault();
        });
    }
    
    document.getElementById('mobile-toggle').addEventListener('click',function(e){
        document.body.classList.toggle('mobile-open');
        e.preventDefault();
    });

  });